module.exports = __webpack_public_path__ + "images/emoji/train2.f050036f618f01ba53df.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/train2.png
// module id = OeBN
// module chunks = 13